"use client";

import { motion, useAnimation } from "framer-motion";
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
const CIRCLES = [{
  cx: 9,
  cy: 5
}, {
  cx: 9,
  cy: 12
}, {
  cx: 9,
  cy: 19
}, {
  cx: 15,
  cy: 5
}, {
  cx: 15,
  cy: 12
}, {
  cx: 15,
  cy: 19
}];
const ROWS = 3;
const VARIANTS = {
  normal: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.25,
      ease: "easeOut"
    }
  },
  animate: data => {
    const row = data.index % ROWS;
    const col = Math.floor(data.index / ROWS);
    const delay = row * 0.15 + col * (ROWS * 0.15 - 0.2);
    return {
      opacity: [1, 0.4, 1],
      scale: [1, 0.85, 1],
      transition: {
        delay,
        duration: 1,
        ease: "easeInOut"
      }
    };
  }
};
const GripVerticalIcon = forwardRef(({
  onMouseEnter,
  onMouseLeave,
  className,
  size = 28,
  ...props
}, ref) => {
  const controls = useAnimation();
  const isControlledRef = useRef(false);
  const isAnimatingRef = useRef(false);
  const startAnimation = useCallback(async () => {
    if (isAnimatingRef.current) return;
    isAnimatingRef.current = true;
    await controls.start("animate");
    await controls.start("normal");
    isAnimatingRef.current = false;
  }, [controls]);
  const stopAnimation = useCallback(async () => {
    if (!isAnimatingRef.current) return;
    await controls.start("normal");
    isAnimatingRef.current = false;
  }, [controls]);
  useImperativeHandle(ref, () => {
    isControlledRef.current = true;
    return {
      startAnimation,
      stopAnimation
    };
  });
  const handleMouseEnter = useCallback(e => {
    if (!isControlledRef.current) startAnimation();
    onMouseEnter?.(e);
  }, [startAnimation, onMouseEnter]);
  const handleMouseLeave = useCallback(e => {
    if (!isControlledRef.current) stopAnimation();
    onMouseLeave?.(e);
  }, [stopAnimation, onMouseLeave]);
  return <div className="contents" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...props}>
      <svg className={["inline-flex items-center justify-center", className].filter(Boolean).join(" ")} fill="none" height={size} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">
        {CIRCLES.map((circle, index) => <motion.circle animate={controls} custom={{
        index
      }} cx={circle.cx} cy={circle.cy} initial="normal" key={`${circle.cx}-${circle.cy}`} r="1" variants={VARIANTS} />)}
      </svg>
    </div>;
});
GripVerticalIcon.displayName = "GripVerticalIcon";
export { GripVerticalIcon };
